import { useEffect, useState, useCallback } from "react";

const KEY = "br-compare";
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

export function useCompare() {
  const [ids, setIds] = useState(read);
  useEffect(() => {
    const sync = () => setIds(read());
    window.addEventListener("br-compare", sync);
    return () => window.removeEventListener("br-compare", sync);
  }, []);
  const save = (next) => {
    // Only deal IDs are stored here (no personal data).
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { console.warn("Compare list not saved:", e?.message || e); }
    window.dispatchEvent(new Event("br-compare"));
  };
  const toggle = useCallback((id) => {
    const cur = read();
    save(cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id].slice(-4));
  }, []);
  const clear = () => save([]);
  return { ids, has: (id) => ids.includes(id), toggle, clear };
}
